// Extract unique values for filter dropdowns
export const extractFilterValues = (data) => {
  const caregivers = [...new Set(data.map((activity) => activity.caregiverName))].sort()
  const activityTypes = [...new Set(data.map((activity) => activity.activityType))].sort()
  const departments = [...new Set(data.map((activity) => activity.department))].sort()
  const statuses = ['Completed', 'In Progress', 'Scheduled', 'Cancelled']

  return {
    caregivers,
    activityTypes,
    departments,
    statuses
  }
}

// Apply filters to activities data
export const applyFilters = (data, filters) => {
  const { searchText, caregiverFilter, activityTypeFilter, statusFilter, dateRange } = filters

  return data.filter((activity) => {
    // Text search
    const textMatch =
      searchText === '' ||
      activity.caregiverName.toLowerCase().includes(searchText.toLowerCase()) ||
      activity.patientName.toLowerCase().includes(searchText.toLowerCase()) ||
      activity.activityType.toLowerCase().includes(searchText.toLowerCase()) ||
      (activity.notes && activity.notes.toLowerCase().includes(searchText.toLowerCase()))

    // Caregiver filter
    const caregiverMatch = caregiverFilter === 'all' || activity.caregiverName === caregiverFilter

    // Activity type filter
    const typeMatch = activityTypeFilter === 'all' || activity.activityType === activityTypeFilter

    // Status filter
    const statusMatch = statusFilter === 'all' || activity.status === statusFilter

    // Date range filter
    let dateMatch = true
    if (dateRange && dateRange[0] && dateRange[1]) {
      const activityDate = new Date(activity.startTime)
      const startDate = dateRange[0].startOf('day').toDate()
      const endDate = dateRange[1].endOf('day').toDate()
      dateMatch = activityDate >= startDate && activityDate <= endDate
    }

    return textMatch && caregiverMatch && typeMatch && statusMatch && dateMatch
  })
}

// Group activities by caregiver for timeline view
export const groupActivitiesByCaregiver = (caregivers, filteredData) => {
  return caregivers
    .map((caregiver) => {
      return {
        caregiver,
        activities: filteredData
          .filter((activity) => activity.caregiverName === caregiver)
          .sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
      }
    })
    .filter((group) => group.activities.length > 0)
}
